import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-difficulties',
  templateUrl: './difficulties.component.html',
  styleUrls: ['./difficulties.component.scss']
})
export class DifficultiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
